/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */
export var durationStep = 25;
export var smallDurationMs = durationStep * 4;
export var mediumDurationMs = durationStep * 14;
export var largeDurationMs = durationStep * 28;